
'use client';

import { useEffect, useState } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col">
      {/* Image Section - 상단 */}
      <div className="relative w-full h-[45vh] sm:h-[55vh] lg:h-[65vh]">
        <img
          src="https://public.readdy.ai/ai/img_res/d2d6715cad0984d78be9331c67301393.jpg"
          alt="Kingdom Bridge Mission 비전"
          className="w-full h-full object-cover object-top"
        />
        {/* 하단 그라데이션 - 자연스러운 연결 */}
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
      </div>

      {/* Content Section - 하단 */}
      <div className="flex-1 bg-white flex items-center justify-center py-8 sm:py-12 lg:py-16 px-5 sm:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-snug sm:leading-tight mb-3 sm:mb-5 break-keep">
            우리는 모두 선교사입니다
          </h1>

          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 break-keep leading-relaxed px-2 sm:px-0">
            여러분들의 기도와 후원이 하나님의 나라를 세웁니다
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
            <a
              href="#about"
              className="w-full sm:w-auto bg-amber-500 text-white px-6 sm:px-8 py-3.5 sm:py-3.5 rounded-full font-semibold text-sm sm:text-base hover:bg-amber-600 transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              KBM 소개
            </a>
            <a
              href="#ministries"
              className="w-full sm:w-auto bg-gray-100 text-gray-700 px-6 sm:px-8 py-3.5 sm:py-3.5 rounded-full font-semibold text-sm sm:text-base hover:bg-gray-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              사역 알아보기
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-9 sm:w-7 sm:h-10 border-2 border-gray-300 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2 sm:w-1.5 sm:h-2.5 bg-gray-400 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
